import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosTributacionPg, { RESOURCE_TRIBUTACION_PG } from '@/auth/permissions/modules/tributacionPg'

const { configuracion, mantenimiento, transacciones, informes } = permisosTributacionPg

export default [
    /**
     * RUTAS DE MANTENIMIENTO
     */
    {
        path: '/tributacion-pg/mantenimiento/paises',
        name: namesMantenimiento.ROUTE_PAISES,
        component: () => import('@pages/tributacion-pg/mantenimiento/Paises.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.paises',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.paises,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.paises'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/distrito-aduanero',
        name: namesMantenimiento.ROUTE_DISTRITO_ADUANERO,
        component: () => import('@pages/tributacion-pg/mantenimiento/DistritoAduanero.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.distrito_aduanero',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.distritoAduanero,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.distrito_aduanero'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/fideicomiso',
        name: namesMantenimiento.ROUTE_FIDEICOMISO,
        component: () => import('@pages/tributacion-pg/mantenimiento/TipoFideicomiso.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.fideicomiso',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.fideicomiso,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.fideicomiso'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/forma-pago',
        name: namesMantenimiento.ROUTE_FORMA_PAGO_COBRO,
        component: () => import('@pages/tributacion-pg/mantenimiento/FormaPagoCobro.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.forma_pago_cobro',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.formaPagoCobro,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.forma_pago_cobro'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/sustento-comprobante',
        name: namesMantenimiento.ROUTE_SUSTENTO_TRIBUTARIO,
        component: () => import('@pages/tributacion-pg/mantenimiento/SustentoComprobante.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.sustento_comprobante',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.sustentoTributario,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.sustento_comprobante'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/retencion-iva',
        name: namesMantenimiento.ROUTE_RETENCION_IVA,
        component: () => import('@pages/tributacion-pg/mantenimiento/RetencionIva.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.retencion_iva',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.retencionIVA,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.retencion_iva'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/exportaciones',
        name: namesMantenimiento.ROUTE_EXPORTACIONES,
        component: () => import('@pages/tributacion-pg/mantenimiento/TipoExportacionIngreso.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.exportaciones',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.exportaciones,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.exportaciones'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/provincias',
        name: namesMantenimiento.ROUTE_PROVINCIAS,
        component: () => import('@pages/tributacion-pg/mantenimiento/Provincias.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.provincias',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.provincias,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.provincias'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/ciudades',
        name: namesMantenimiento.ROUTE_CIUDADES,
        component: () => import('@pages/tributacion-pg/mantenimiento/Ciudades.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.ciudades',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.ciudades,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.ciudades'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/comprobante',
        name: namesMantenimiento.ROUTE_COMPROBANTE,
        component: () => import('@pages/tributacion-pg/mantenimiento/TipoComprobante.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.comprobante',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.comprobante,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.comprobante'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/punto-emision',
        name: namesMantenimiento.ROUTE_PUNTO_EMISION,
        component: () => import('@pages/tributacion-pg/mantenimiento/punto-emision/Index.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.punto_emision',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.puntoEmision,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.punto_emision'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/regimen-fiscal',
        name: namesMantenimiento.ROUTE_REGIMEN_FISCAL,
        component: () => import('@pages/tributacion-pg/mantenimiento/CodigoRegimen.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.regimen_fiscal',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.regimenFiscal,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.regimen_fiscal'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/codigos-formulario-104',
        name: namesMantenimiento.ROUTE_CODIGO_FORMULARIO_104,
        component: () => import('@pages/tributacion-pg/mantenimiento/CodigosFormulario104.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.codigo_formulario_104',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.codigoFormulario104,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.codigo_formulario_104'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/politica-iva',
        name: namesMantenimiento.ROUTE_POLITICA_IVA,
        component: () => import('@pages/tributacion-pg/mantenimiento/politica-iva/Index.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.politica_iva',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.politicaIVA,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.politica_iva'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/tipo-contribuyente',
        name: namesMantenimiento.ROUTE_TIPO_CONTRIBUYENTE,
        component: () => import('@pages/tributacion-pg/mantenimiento/TipoContribuyente.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.tipo_contribuyente',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.tipoContribuyente,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.tipo_contribuyente'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/partidas-arancelarias/gestion-partidas-arancelarias',
        name: namesMantenimiento.ROUTE_GESTION_PARTIDAS_ARANCELARIAS,
        component: () =>
            import('@pages/tributacion-pg/mantenimiento/partidasArancelarias/GestionPartidaArancelaria.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.gestion_partidas_arancelarias',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.gestionPartidasArancelarias,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.gestion_partidas_arancelarias'
            ),
        },
    },
    {
        path: '/tributacion-pg/mantenimiento/paraiso-fiscal',
        name: namesMantenimiento.ROUTE_PARAISO_FISCAL,
        component: () => import('@pages/tributacion-pg/mantenimiento/ParaisoFiscal.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.paraiso_fiscal',
            resource: RESOURCE_TRIBUTACION_PG,
            action: mantenimiento.paraisoFiscal,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.mantenimiento',
                'tributacion.subopciones.paraiso_fiscal'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACION
     */
    {
        path: '/tributacion-pg/configuracion/transaccion-tributaria',
        name: namesConfiguracion.ROUTE_TRANSACCION_TRIBUTARIA,
        component: () => import('@pages/tributacion-pg/configuracion/TiposTransaccion.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.transaccion_tributaria',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.transaccionTributaria,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.transaccion_tributaria'
            ),
        },
    },
    {
        path: '/tributacion-pg/configuracion/comprobantes-autorizados',
        name: namesConfiguracion.ROUTE_COMPROBANTE_AUTORIZADO,
        component: () => import('@pages/tributacion-pg/configuracion/ComprobantesAutorizados.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.comprobantes_autorizados',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.comprobanteAutorizado,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.comprobantes_autorizados'
            ),
        },
    },
    {
        path: '/tributacion-pg/configuracion/parametros-rdep',
        name: namesConfiguracion.ROUTE_PARAMETROS_RDEP,
        component: () => import('@/views/pages/tributacion-pg/configuracion/VariablesRdep.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.parametros_rdep',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.parametrosRdep,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.parametros_rdep'
            ),
        },
    },
    {
        path: '/tributacion-pg/configuracion/conceptos-retencion-fuente',
        name: namesConfiguracion.ROUTE_CONCEPTOS_RETENCION_FUENTE,
        component: () => import('@pages/tributacion-pg/configuracion/ConceptosRetencionFuente.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.conceptos_retencion_fuente',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.conceptosRetencionFuente,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.conceptos_retencion_fuente'
            ),
        },
    },
    {
        path: '/tributacion-pg/configuracion/campos-formulario-103',
        name: namesConfiguracion.ROUTE_CAMPOS_FORMULARIO_103,
        component: () => import('@pages/tributacion-pg/configuracion/CamposFormulario103.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.campos_formulario_103',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.camposFormulario103,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.campos_formulario_103'
            ),
        },
    },
    {
        path: '/tributacion-pg/configuracion/cierre-sri',
        name: namesConfiguracion.ROUTE_CIERRE_SRI,
        component: () => import('@pages/tributacion-pg/configuracion/CierreSri.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.cierre_sri',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.cierreSRI,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.cierre_sri'
            ),
        },
    },
    {
        path: '/tributacion-pg/configuracion/matriz-tipo-contribuyente',
        name: namesConfiguracion.ROUTE_MATRIZ_TIPO_CONTRIBUYENTE,
        component: () => import('@pages/tributacion-pg/configuracion/MatrizTipoContribuyente.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.matriz_tipo_contribuyente',
            resource: RESOURCE_TRIBUTACION_PG,
            action: configuracion.matrizTipoContribuyente,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.configuracion',
                'tributacion.subopciones.matriz_tipo_contribuyente'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/tributacion-pg/transacciones/rdep/migrar-excel',
        name: namesTransacciones.ROUTE_MIGRAR_EXCEL_RDEP,
        component: () => import('@pages/tributacion-pg/transacciones/rdep/RdepMigrarExcel.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.migrar_excel_rdep',
            resource: RESOURCE_TRIBUTACION_PG,
            action: transacciones.rdep.migrarExcelRDEP,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'tributacion.subopciones.RDEP',
                'tributacion.subopciones.migrar_excel'
            ),
        },
    },
    {
        path: '/tributacion-pg/transacciones/rdep/generar-xml',
        name: namesTransacciones.ROUTE_GENERAR_XML_RDEP,
        component: () => import('@/views/pages/tributacion-pg/transacciones/rdep/RdepProcesos.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.generar_xml_rdep',
            resource: RESOURCE_TRIBUTACION_PG,
            action: transacciones.rdep.generarXmlRDEP,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'tributacion.subopciones.RDEP',
                'tributacion.subopciones.generar_xml'
            ),
        },
    },
    {
        path: '/tributacion-pg/transacciones/ats/generar-xml',
        name: namesTransacciones.ROUTE_GENERAR_XML_ATS,
        component: () => import('@/views/pages/tributacion-pg/transacciones/ats/AtsGenerarXml.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.generar_xml_ats',
            resource: RESOURCE_TRIBUTACION_PG,
            action: transacciones.generarXmlATS,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'tributacion.subopciones.generar_xml_ats'
            ),
        },
    },
    {
        path: '/tributacion-pg/transacciones/solicitud-anulacion-documentos-electronicos',
        name: namesTransacciones.ROUTE_SOLICITUD_ANULACION_DOCUMENTOS_ELECTRONICOS,
        component: () =>
            import('@pages/tributacion-pg/transacciones/documento-retencion/solicitud-anulacion/Index.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.solicitud_anulacion_doc_electronicos',
            resource: RESOURCE_TRIBUTACION_PG,
            action: transacciones.solicitudAnulacionDocElectronicos,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'tributacion.subopciones.solicitud_anulacion_doc_electronicos'
            ),
        },
    },
    {
        path: '/tributacion-pg/transacciones/documentos-electronicos/retenciones/gestion',
        name: namesTransacciones.ROUTE_BANDEJA_DOCUMENTOS_RETENCION,
        component: () => import('@pages/tributacion-pg/transacciones/documento-retencion/gestion/Index.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.bandeja_documentos_retencion',
            resource: RESOURCE_TRIBUTACION_PG,
            action: transacciones.documentoRetencion,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'tributacion.subopciones.bandeja_documentos_retencion'
            ),
        },
    },
    {
        path: '/tributacion-pg/transacciones/documentos-electronicos/retenciones/:numDocumento?',
        name: namesTransacciones.ROUTE_DOCUMENTO_RETENCION,
        component: () => import('@pages/tributacion-pg/transacciones/documento-retencion'),
        meta: {
            title: 'i18n:tributacion.subopciones.documento_retencion',
            resource: RESOURCE_TRIBUTACION_PG,
            action: transacciones.documentoRetencion,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'tributacion.subopciones.documento_retencion'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/tributacion-pg/informes/reporte-103',
        name: namesInformes.ROUTE_REPORTE_103,
        component: () => import('@pages/tributacion-pg/informes/formulario-103/ReporteForm103.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.reporte_103',
            resource: RESOURCE_TRIBUTACION_PG,
            action: informes.reporte103,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.informes',
                'tributacion.subopciones.reporte_103'
            ),
        },
    },
    {
        path: '/tributacion-pg/informes/reporte-104',
        name: namesInformes.ROUTE_REPORTE_104,
        component: () => import('@pages/tributacion-pg/informes/ReporteFormulario104.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.reporte_104',
            resource: RESOURCE_TRIBUTACION_PG,
            action: informes.reporte104,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.informes',
                'tributacion.subopciones.reporte_104'
            ),
        },
    },
    {
        path: '/tributacion-pg/informes/reporte-107',
        name: namesInformes.ROUTE_REPORTE_107,
        component: () => import('@pages/tributacion-pg/informes/ReporteForm107.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.reporte_107',
            resource: RESOURCE_TRIBUTACION_PG,
            action: informes.reporte107,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.informes',
                'tributacion.subopciones.reporte_107'
            ),
        },
    },
    {
        path: '/tributacion-pg/informes/reporte-tabulado-rdep',
        name: namesInformes.ROUTE_REPORTE_TABULADO_RDEP,
        component: () => import('@pages/tributacion-pg/informes/ReportesTabulados.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.reporte_tabulado_rdep',
            resource: RESOURCE_TRIBUTACION_PG,
            action: informes.reporteTabuladoRDEP,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.informes',
                'tributacion.subopciones.reporte_tabulado_rdep'
            ),
        },
    },
    {
        path: '/tributacion-pg/informes/reporte-control-error-usuario-contable',
        name: namesInformes.ROUTE_REPORTE_CONTROL_ERROR_USUARIO_CONTABLE,
        component: () => import('@pages/tributacion-pg/informes/ControlErroresUsuariosContables.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.reporte_control_error',
            resource: RESOURCE_TRIBUTACION_PG,
            action: informes.reporteControlErrorUsuarioContable,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.informes',
                'tributacion.subopciones.reporte_control_error'
            ),
        },
    },

    {
        path: '/tributacion-pg/informes/ats-importacion',
        name: namesInformes.ROUTE_ATS_IMPORTACION,
        component: () => import('@pages/tributacion-pg/informes/AtsImportacion.vue'),
        meta: {
            title: 'i18n:tributacion.subopciones.ats_importacion',
            resource: RESOURCE_TRIBUTACION_PG,
            action: informes.atsImportacion,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.informes',
                'tributacion.subopciones.ats_importacion'
            ),
        },
    },
] as RouteConfig[]
